/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

export const REGIONAL_MAP_FULL_DATA_COLUMN = [
  {
    table: 'measures',
    columns: 'region_full_map',
  },
];
export const STAY_DATE_RANGE = 'Stay Date Range';
export const BOOKING_DATE_RANGE = 'Booking Date Range';
export const PMS_SYNC = 'PMS Sync';
export const SELECTED_CURRENCY = 'Selected Currency';
export const BREAKDOWN = 'Breakdown';
export const FOCUSED_BREAKDOWN_SEGMENTS = 'Focused Breakdown Segments';
export const FORCE_UPDATE_EXPORT_COLUMN_NAMES = [
  'AssignedChannel',
  'channel_mapped',
  'marketSegmentCode',
  'AssignedMarketSegment',
  'rateCategoryCode',
];
export const LEVEL_CONFIG = [
  { key: 'continent', name: 'contintentLevelFilter' },
  { key: 'country', name: 'countryLevelFilter' },
  { key: 'state', name: 'stateLevelFilter' },
  { key: 'city', name: 'cityLevelFilter' },
];
export const LEVELS = ['Continent', 'Country', 'State', 'City'];
